const Permission = ({ children, access }) => {

    const permissions = JSON.parse(localStorage.getItem('permissions'));
    const hasPermission = (requiredPermission) => {
        return permissions.some(permission => permission.permission_slug === requiredPermission);
    };

    return (
        <>
            {

                hasPermission(access) ? children : null
            }
        </>
    );
};

export default Permission;
